import React from "react";
import { Header } from "../layouts/Header.jsx";
import { mainMenu } from "../constants/data.js";
import Footer from "../layouts/Footer.jsx";

export default function Homepage() {
  // URL'den tab ID'sini belirleyen fonksiyon
  const getInitialTabFromURL = () => {
    const path = window.location.pathname;

    // Path'i temizle ve parçalara ayır (boş segmentleri filtrele)
    const segments = path.split("/").filter((segment) => segment !== "");

    // Path'in 'sunum' içermesi gerekiyor (örn: /sunum/mynet)
    // Direkt /mynet gibi URL'ler için default döndür
    if (!segments.includes("sunum")) {
      return 1; // Default: Onedio
    }

    const brandName = segments[segments.length - 1];

    // 'sunum' kelimesi son segment ise (örn: /sunum veya /sunum/)
    if (brandName === "sunum") {
      return 1; // Default: Onedio
    }

    // mainMenu'den link field'ına göre eşleşen markayı bul
    const matchedTab = mainMenu.find((tab) => tab.link === brandName);

    // Eşleşme varsa o tab'ın id'sini, yoksa default (1 - Onedio)
    return matchedTab ? matchedTab.id : 1;
  };

  const [activeTabIndex, setActiveTabIndex] = React.useState(
    getInitialTabFromURL()
  );

  // Tab değiştiğinde URL'i güncelle
  React.useEffect(() => {
    const brand = mainMenu.find((tab) => tab.id === activeTabIndex);
    if (brand) {
      const newPath = `/sunum/${brand.link}`;
      // Loop önleme: sadece farklıysa güncelle
      if (window.location.pathname !== newPath) {
        window.history.pushState(null, "", newPath);
      }
    }
  }, [activeTabIndex]);

  // Browser back/forward butonları için
  React.useEffect(() => {
    const handlePopState = () => {
      const newTabId = getInitialTabFromURL();
      setActiveTabIndex(newTabId);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <React.Fragment>
      <Header
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />
      {mainMenu.map((tab) => {
        return tab.id === activeTabIndex ? tab.component : null;
      })}
      <Footer />
    </React.Fragment>
  );
}
